import { Grid } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useForm } from "../../../../hooks/useForm";
import { useTranslation } from "react-i18next";
import { overflowButtonStyle } from "../../../../helpers/styles";
import DateField from "../../../field/DateField/DateField";
import { isEmptyValue } from "../../../../helpers/methods";
import useIcoService from "../../../../services/icoService";
import { useCallback, useState } from "react";


const InterestForChosenDateTab = () => {
  const { t } = useTranslation();
  const {
    formValue,
    onChangeDate
  } = useForm()

  const [genereting, setGenereting] = useState(false)

  const {
    getInterestForDateReport
  } = useIcoService();

  const onClickGenerate = useCallback(() =>{
    setGenereting(true)
    getInterestForDateReport(formValue, setGenereting)
  
  })

  return (
    <Grid
      item
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      columnSpacing={1}
    >         <Grid item xs={12} md={2.5} marginBottom={1}>
        <DateField
          name={"date_to_calculate"}
          label={t("tabs.interest_for_chosen_date_tab.select_date_to_calculate")}
          value={formValue?.date_to_calculate}
          onChange={onChangeDate}
          showClearIcon={true}
        />
      </Grid>
      <Grid item xs={12} md={2} marginBottom={1}>
        <LoadingButton
          fullWidth
          variant="contained"
          size="small"
          sx={overflowButtonStyle}
          disabled={isEmptyValue(formValue?.date_to_calculate)}
          onClick={onClickGenerate}
          loading={genereting}
        >
          {t("tabs.interest_for_chosen_date_tab.download_report")}
        </LoadingButton>
      </Grid>

    </Grid>
  );
};

InterestForChosenDateTab.propTypes = {

};

InterestForChosenDateTab.defaultProps = {};

export default InterestForChosenDateTab;
